import React, { RefObject } from 'react';
import parse from 'html-react-parser';
import './sticky-banner.scss';
type StickyBannerProps = {
  className?: string;
  heading: string;
  btnCopy: string;
  btnLink: string;
  refElement?: RefObject<any>;
};
type StickyBannerState = {
  toShow: boolean;
};
class StickyBanner extends React.Component<StickyBannerProps, StickyBannerState> {
  observer: any;
  constructor(props: StickyBannerProps) {
    super(props);
    this.close = this.close.bind(this);
  }
  state = {
    toShow: false,
  };
  close() {
    this.setState(() => ({
      toShow: false,
    }));
    if (this.observer && this.props.refElement) {
      this.observer.unobserve(this.props.refElement.current);
    }
  }
  componentDidMount() {
    if (this.props.refElement) {
      this.observer = new IntersectionObserver(
        (entries, obs) => {
          for (const entry of entries) {
            this.setState(() => ({
              toShow: !entry.isIntersecting,
            }));
          }
        },
        {
          rootMargin: '5px',
          threshold: 0,
        },
      );
      this.observer.observe(this.props.refElement.current);
      return () => {
        this.observer.disconnect();
      };
    } else {
      this.setState(() => ({
        toShow: true,
      }));
    }
  }
  render() {
    const cl = this.props.class || this.props.className || '';

    return (
      <div
        className={`${cl} position-fixed sticky-banner bg-midnight-blue text-white text-center py-2 px-3 p-md-3 w-100 w-md-auto ${
          this.state.toShow ? 'toShow' : ''
        }`}>
        <div className="position-relative d-md-flex align-items-center">
          <h6 className="mb-md-0 pe-4 pe-md-5">{parse(this.props.heading)}</h6>
          <a
            className="btn btn-primary w-100 w-md-auto me-md-5"
            href={this.props.btnLink}
            data-op="SLD">
            {parse(this.props.btnCopy)}
          </a>
          <button
            className="close reset-btn"
            aria-label="Close"
            data-link-both="sld-close"
            onClick={this.close}>
            <span className="ecs-font-icon-act-close"></span>
          </button>
        </div>
      </div>
    );
  }
}

export default StickyBanner;
